import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
  LinearProgress,
  Typography,
  useTheme,
} from "@material-ui/core";
import React from "react";
import { LSDBTimer } from "../../common/Timer";
import CharacterizationQueueDialog from "../common/CharacterizationQueueDialog";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import {
  useDispositionsByName,
  useWetLeakageData,
} from "../../common/services/dispositionServices";
import {
  useSubmitMeasurementResult,
  useSubmitProcedureResult,
  useSubmitStepResult,
} from "../common/testMutations";
import { useFetchContext } from "../../common/FetchContext";
import { useAuthContext } from "../../common/AuthContext";
import { ErrorMessage } from "../../common/ErrorMessage";
import measurementSubmission from "../common/measurementSubmission";
import TesterTypes from "../common/TesterTypes";
import CheckCircle from "@material-ui/icons/CheckCircle";
import { green, red } from "@material-ui/core/colors";
import CancelIcon from "@material-ui/icons/Cancel";
import { TextField } from "formik-material-ui";
import { DateTimePicker } from "formik-material-ui-pickers";
import { ConfirmationDialog } from "../../common/ConfirmationDialog";

export const InsulationTester = ({
  testerData,
  procedureResultData,
  assetData,
  setClearedValues,
  historicUser,
  historicDate,
  historicData,
  historicDisposition,
  closeHistoricModal,
  startDateTime,
}: any) => {
  const history = useHistory();
  const {
    error: errorDispositionPassed,
    data: dispositionPassed,
    isLoading: isLoadingDispositionPassed,
    isError: isErrorDispositionPassed,
  } = useDispositionsByName("Pass");

  const {
    error: errorDispositionRequiresReview,
    data: dispositionRequiresReview,
    isLoading: isLoadingDispositionRequiresReview,
    isError: isErrorDispositionRequiresReview,
  } = useDispositionsByName("Requires Review");

  const {
    error: errorWetleakage,
    data: wetLeakageData,
    isLoading: isLoadingWetleakage,
    isError: isErrorwetLeakage,
  } = useWetLeakageData();

  const {
    error: errorDispositionFailed,
    data: dispositionFailed,
    isLoading: isLoadingDispositionFailed,
    isError: isErrorDispositionFailed,
  } = useDispositionsByName("Fail");

  const [testStatus, setTestStatus] = React.useState(false);
  const [submissionStatus, setSubmissionStatus] = React.useState(false);

  const [cementedDialogOpen, setCementedDialogOpen] = React.useState(false);
  const [shown, setShown] = React.useState(false);

  const { mutateAsync: mutateSubmitMeasurementResult } =
    useSubmitMeasurementResult();
  const { mutateAsync: mutateSubmitStepResult } = useSubmitStepResult();
  const { mutateAsync: mutateSubmitProcedureResult } =
    useSubmitProcedureResult();
  const { authAxios } = useFetchContext();
  const { dispatch } = useAuthContext();
  const theme = useTheme();
  const [confirmationDialogOpen, setConfirmationDialogOpen] =
    React.useState(false);

  if (
    isErrorDispositionPassed ||
    isErrorDispositionFailed ||
    isErrorDispositionRequiresReview
  ) {
    return (
      <>
        {isErrorDispositionPassed && (
          <ErrorMessage error={errorDispositionPassed} />
        )}
        {isErrorDispositionRequiresReview && (
          <ErrorMessage error={errorDispositionRequiresReview} />
        )}
        {isErrorDispositionFailed && (
          <ErrorMessage error={errorDispositionFailed} />
        )}
      </>
    );
  }

  if (
    isLoadingDispositionFailed ||
    isLoadingDispositionPassed ||
    isLoadingDispositionRequiresReview ||
    isLoadingWetleakage
  ) {
    return (
      <div style={theme.containerMargin}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      </div>
    );
  }

  if (submissionStatus && !historicData) {
    return (
      <Backdrop open={submissionStatus}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (submissionStatus && historicData) {
    return (
      <div style={theme.containerMargin}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      </div>
    );
  }

  const getValueToSubmit = (name: string, values: any) => {
    switch (name) {
      case "Insulation Resistance":
        return values.insulationResistance;
      case "Leakage Current":
        return values.leakageCurrent;
      case "Test Voltage":
        return values.systemVoltage;
      case "Stress Voltage":
        return values.waterTemperature;
      case "Current Trip Setpoint":
        return values.currentTripSetpoint;
      case "Insulation Test Pass/Fail":
        return testStatus;
      default:
        return null;
    }
  };

  return (
    <Grid
      container
      direction="row"
      justify="space-between"
      alignItems="center"
      spacing={1}
    >
      <Grid item md={6} xs={12}>
        <LSDBTimer />
      </Grid>
      <Grid item md={6} xs={12}>
        <CharacterizationQueueDialog
          procedureResultData={procedureResultData}
          historicData={historicData}
          assetData={assetData}
        />
      </Grid>
      <Grid item xs={12}>
        <Formik
          initialValues={{
            moduleHeight: testerData.module_height,
            moduleWidth: testerData.module_width,
            systemVoltage: testerData.system_voltage,
            cemented: testerData.cemented,
            waterTemperature: "",
            leakageCurrent: "",
            insulationResistance: "",
            currentTripSetpoint: 0.184,
            calibrationdate: "",
            resistivity: wetLeakageData?.latest_wetleakage ?? "",
          }}
          validationSchema={Yup.object({
            moduleHeight: Yup.number().required("Field must be required"),
            moduleWidth: Yup.number().required("Field must be required"),
            systemVoltage: Yup.number().required("Field must be required"),
            waterTemperature: Yup.number().required("Field must be required"),
            leakageCurrent: Yup.number().required("Field must be required"),
            insulationResistance: Yup.number().required(
              "Field must be required",
            ),
            currentTripSetpoint: Yup.number().required(
              "Field must be required",
            ),
          })}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            await measurementSubmission({
              testerType: TesterTypes.InsulationTest,
              setConfirmationDialogOpen,
              setSubmissionStatus,
              setSubmittingForm: setSubmitting,
              historicData,
              historicDate,
              historicUser,
              historicDisposition,
              assetData,
              procedureResultData,
              values,
              dispositionFailed,
              dispositionPassed,
              minimumMeasurementResultsLength: 6,
              getValueToSubmit,
              startDateTime,
              dispositionRequiresReview,
              closeHistoricModal,
              resetForm,
              history,
              dispatch,
              authAxios,
              mutateSubmitMeasurementResult,
              mutateSubmitStepResult,
              mutateSubmitProcedureResult,
              setClearedValues,
            });
          }}
        >
          {({
            errors,
            touched,
            submitForm,
            setFieldValue,
            initialValues,
            values,
          }) => {
            React.useEffect(() => {
              if (values.cemented) {
                setFieldValue(
                  "systemVoltage",
                  Number((1.35 * testerData.system_voltage).toFixed(2)),
                );
              } else {
                setFieldValue("systemVoltage", testerData.system_voltage);
              }
            }, [values.cemented]);

            React.useEffect(() => {
              if (values.cemented && !shown) {
                setCementedDialogOpen(true);
                setShown(true);
              }
            }, [values.cemented, shown]);

           

            const calculateResistance = (
              e: React.ChangeEvent<HTMLInputElement>,
            ) => {
              const current = e.target.valueAsNumber;

              setFieldValue("leakageCurrent", current);

              if (!current) {
                setFieldValue("insulationResistance", "");
                return;
              }

              const moduleHeight = values.moduleHeight / 1000;
              const moduleWidth = values.moduleWidth / 1000;

              const area = moduleHeight * moduleWidth;

              const voltage = values.cemented
                ? 1.35 * testerData.system_voltage
                : testerData.system_voltage;

              // IMPORTANT:
              // Confirm whether leakage current is entered in mA or A.
              const currentInAmps = current / 1000;

              const resistance = ((voltage / currentInAmps) * area) / 1000;

              setFieldValue(
                "insulationResistance",
                Number(resistance.toFixed(2)),
              );
            };
            const renderResults = () => {
              if (values.insulationResistance !== "") {
                if (parseFloat(values.insulationResistance) > 40) {
                  setTestStatus(true);
                  return (
                    <>
                      <CheckCircle style={{ color: green[500] }} />
                      <Typography variant="subtitle1">Passed</Typography>
                    </>
                  );
                }
                setTestStatus(false);
                return (
                  <>
                    <CancelIcon style={{ color: red[500] }} />
                    <Typography variant="subtitle1">Failed</Typography>
                    <Typography variant="body2">less than :40MΩ·m²</Typography>
                  </>
                );
              }
            };

            return (
              <Form>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="center"
                  spacing={4}
                >
                  <Grid item xs={12} md={2}>
                    <Field
                      id="moduleHeight"
                      type="number"
                      data-testid="moduleHeight"
                      name="moduleHeight"
                      disabled
                      value={initialValues.moduleHeight}
                      helperText={
                        touched.moduleHeight ? errors.moduleHeight : ""
                      }
                      error={
                        touched.moduleHeight && Boolean(errors.moduleHeight)
                      }
                      component={TextField}
                      label="Module Height"
                      style={{ marginBottom: 32 }}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">mm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Field
                      id="moduleWidth"
                      type="number"
                      data-testid="moduleWidth"
                      name="moduleWidth"
                      value={initialValues.moduleWidth}
                      disabled
                      helperText={touched.moduleWidth ? errors.moduleWidth : ""}
                      error={touched.moduleWidth && Boolean(errors.moduleWidth)}
                      component={TextField}
                      label="Module Width"
                      style={{ marginBottom: 32 }}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">mm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Field
                      id="systemVoltage"
                      type="number"
                      data-testid="systemVoltage"
                      name="systemVoltage"
                      helperText={
                        touched.systemVoltage ? errors.systemVoltage : ""
                      }
                      error={
                        touched.systemVoltage && Boolean(errors.systemVoltage)
                      }
                      component={TextField}
                      label="Applied Voltage"
                      style={{ marginBottom: 32 }}
                      fullWidth
                      value={values.systemVoltage}
                      disabled
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">V</InputAdornment>
                        ),
                        style: {
                          color: values.cemented ? "blue" : "inherit",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Field
                      id="waterTemperature"
                      type="number"
                      data-testid="waterTemperature"
                      name="waterTemperature"
                      helperText={
                        touched.waterTemperature ? errors.waterTemperature : ""
                      }
                      error={
                        touched.waterTemperature &&
                        Boolean(errors.waterTemperature)
                      }
                      component={TextField}
                      label="Stress Voltage"
                      style={{ marginBottom: 32 }}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">V</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    
                    <Field
                      id="leakageCurrent"
                      name="leakageCurrent"
                      type="number"
                      component={TextField}
                      label="Leakage Current"
                      style={{ marginBottom: 32 }}
                      onChange={calculateResistance}
                      helperText={
                        touched.leakageCurrent ? errors.leakageCurrent : ""
                      }
                      error={
                        touched.leakageCurrent && Boolean(errors.leakageCurrent)
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">mA</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    
                    <Field
                      component={TextField}
                      name="insulationResistance"
                       id="insulationResistance"
                      type="number"
                      data-testid="insulationResistance"
                      helperText={
                        touched.insulationResistance
                          ? errors.insulationResistance
                          : ""
                      }
                      error={
                        touched.insulationResistance &&
                        Boolean(errors.insulationResistance)
                      }
                      label="Insulation Resistance"
                      fullWidth
                      disabled
                      value={values.insulationResistance}
                      style={{ marginBottom: 32 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">MΩ·m²</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Field
                      id="currentTripSetpoint"
                      type="number"
                      data-testid="currentTripSetpoint"
                      name="currentTripSetpoint"
                      helperText={
                        touched.currentTripSetpoint
                          ? errors.currentTripSetpoint
                          : ""
                      }
                      error={
                        touched.currentTripSetpoint &&
                        Boolean(errors.currentTripSetpoint)
                      }
                      component={TextField}
                      label="Current Trip Setpoint"
                      style={{ marginBottom: 32 }}
                      fullWidth
                      value={values.currentTripSetpoint}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">mA</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Field
                      name="calibrationdate"
                      component={DateTimePicker}
                      format="YYYY-MM-DD"
                      style={{ marginBottom: 32 }}
                      label="Calibration Date"
                      inputVariant="outlined"
                      data-testid="calibrationdate"
                      value={values.calibrationdate}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Field
                      id="resistivity"
                      type="number"
                      data-testid="resistivity"
                      name="resistivity"
                      component={TextField}
                      label="Water resistivity"
                      fullWidth
                      style={{ marginBottom: 32 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">Ω.cm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}></Grid>

                  <Grid xs={12} md={2}>
                    {renderResults()}
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Button
                      variant="contained"
                      style={theme.btnSubmit}
                      fullWidth
                      onClick={() => setConfirmationDialogOpen(true)}
                    >
                      Save Measurement
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Button
                      variant="contained"
                      style={theme.btnClear}
                      fullWidth
                      onClick={() => setClearedValues(true)}
                    >
                      Clear
                    </Button>
                  </Grid>
                </Grid>
                <ConfirmationDialog
                  id="insulation-test-confirmation"
                  keepMounted
                  open={confirmationDialogOpen}
                  title="Insulation Test Confirmation"
                  content="Are you sure that you want to submit this Insulation Test?"
                  onCancel={() => setConfirmationDialogOpen(false)}
                  onSubmit={submitForm}
                />
                <Dialog
                  open={cementedDialogOpen}
                  onClose={() => setCementedDialogOpen(false)}
                >
                  <DialogTitle>Cemented Module Detected</DialogTitle>
                  <DialogContent>
                    <Typography>
                      This Unit Type uses a Cemented Joint design, the applied
                      voltage should be{" "}
                      <strong>{values.systemVoltage} V</strong>. Please select
                      the correct test program.
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => setCementedDialogOpen(false)}
                      color="primary"
                    >
                      OK
                    </Button>
                  </DialogActions>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
      </Grid>
    </Grid>
  );
};
